import { render } from "./CookiesNotification.vue?vue&type=template&id=7b1b20bc&scoped=true&ts=true"
import script from "./CookiesNotification.vue?vue&type=script&lang=ts"
export * from "./CookiesNotification.vue?vue&type=script&lang=ts"

import "./CookiesNotification.vue?vue&type=style&index=0&id=7b1b20bc&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1b20bc"]])

export default __exports__